export default __webpack_public_path__ + "static/media/EUS_2x.cd875145.png";